const button = document.getElementById('hamburger')
const menu = document.querySelector( 'header nav' )

button.addEventListener( 'click', e => {
  button.classList.toggle( 'open' )
  menu.classList.toggle( 'open' )
})
